import { makeStyles } from '@material-ui/core/styles'

export const scarletWellWidgetStyles = makeStyles((theme) => ({
  gridContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    height: 478,
    overflowY: 'clip',
    margin: 0,
    width: 335,
    maxHeight: 478,
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 196px)',
    },
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  searchBarContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    width: '100%',
    marginTop: 5,
    marginBottom: 5,
  },
  searchBar: {
    width: '70%',
    marginTop: 5,
    marginBottom: 5,
  },
  searchBarButton: {
    cursor: 'pointer',
    '&:hover': {
      border: `2px solid ${theme.palette.base.lightGray}`,
    },
  },
  tabBackground: {
    overflowY: 'hidden',
    width: '100%',
    minHeight: 35,
    height: '35px',
  },
  modalTabs: {
    width: 335,
    height: 35,
    minHeight: 35,
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  tabTextLabel: {
    marginRight: 10,
  },
  text: {
    color: theme.palette.primary.headerText,
    margin: 10,
  },
  // check-in tab
  checkinRoot: {
    padding: '6px',
    overflowY: 'auto',
    height: 478,
    maxHeight: 478,
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 231px)',
    },
  },
  mainImage: {
    width: '100%',
    height: '90px',
    objectFit: 'cover',
    borderRadius: '5px',
    [theme.breakpoints.down(769)]: {
      height: '104px',
    },
    [theme.breakpoints.down(400)]: {
      height: '102px',
    },
  },
  checkInCard: {
    height: '110px',
    padding: 5,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    color: theme.palette.primary.headerText,
    backgroundColor: theme.palette.paper.secondary,
  },
  checkinTextGreeting: {
    marginLeft: '4px',
    fontWeight: theme.typography.fontWeightBold,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  checkinText: {
    marginLeft: '4px',
  },
  // Wellness Engagement specific styles
  engagementCard: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(1),
    backgroundColor: theme.palette.paper.secondary,
  },
  engagementHeader: {
    color: theme.palette.primary.headerText,
    marginBottom: theme.spacing(0.5),
    fontWeight: theme.typography.fontWeightMedium,
  },
  iconRow: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'nowrap',
    marginBottom: theme.spacing(1),
  },
  iconWrapperBase: {
    borderRadius: '50%',
    width: 32,
    height: 32,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    margin: '2px',
    flexShrink: 0,
    [theme.breakpoints.down(400)]: {
      width: 28,
      height: 28,
    },
  },
  activeIconWrapper: {
    backgroundColor: theme.color.rutgersRed,
  },
  inactiveIconWrapper: {
    backgroundColor: theme.color.lightGray,
  },
  scoreCardWrapper: {
    backgroundColor: theme.palette.backgroundColor.secondary,
    padding: theme.spacing(0.5, 1),
  },
  scoreCardInnerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(0.5),
  },
  scoreText: {
    color: theme.palette.primary.headerText,
    fontWeight: theme.typography.fontWeightMedium,
  },
  infoRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  infoText: {
    maxWidth: '60%',
    color: theme.palette.primary.headerText,
  },
  learnMoreBtn: {
    backgroundColor: theme.color.rutgersRed,
    color: theme.color.white,
    '&:hover': {
      backgroundColor: theme.color.darkerRed, // slightly darker hover state
    },
  },
  totalScoreBtn: {
    width: '100%',
    backgroundColor: theme.color.rutgersRed,
    color: theme.color.white,
    marginTop: theme.spacing(1),
    '&:hover': {
      backgroundColor: theme.color.darkerRed,
    },
  },
}))

export default scarletWellWidgetStyles
